import React from 'react';

import GiveawayCard from '../../components/giveaway-card/giveaway-card';
import { Label } from '../../components/label/label';
import { SectionHero } from '../../components/section/section-hero';
import { SectionTitle } from '../../components/section/section-title';
import SuccessStoryCard from '../../components/success-story-card/success-story-card';
import { Text } from '../../components/text/text';
import { Translate } from '../../components/translate';
import { StoreContext } from '../../store/store';
import Cards from './cards/cards';
import './home.scss';

export const Home: React.FC = () => {
  const { state } = React.useContext(StoreContext);
  const { isClient } = state?.config;

  return (
    <React.Fragment>
      <SectionHero className="bd-home__hero">
        <Label color="#98e5b9">
          <Text size="large">
            <Translate id="translate.home.page.hashtag" />
          </Text>
        </Label>
        <SectionTitle weight="bold" level="1">
          <Translate id="translate.home.page.title" />
        </SectionTitle>

        <Text align="center" size="large">
          <Translate id="translate.home.page.subtitle" />
        </Text>
      </SectionHero>
      <Cards />
      {isClient ? <GiveawayCard /> : <SuccessStoryCard />}
    </React.Fragment>
  );
};
